import { IN_PROGRESS_STATUSES } from './taskStatus'

interface OrderedTask {
    id?: number
    status: string
    plannedLoadingDate?: string | null
}

/** Планове завантаження в мс; без дати або з некоректною — у кінець */
const plannedTime = (task: OrderedTask): number => {
    const time = task.plannedLoadingDate ? Date.parse(task.plannedLoadingDate) : NaN
    return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time
}

/** Раніше завантаження — вище; за рівності — менший номер завдання */
const byPlannedLoading = (a: OrderedTask, b: OrderedTask): number =>
    plannedTime(a) - plannedTime(b) || (a.id ?? 0) - (b.id ?? 0)

/**
 * «Зараз»: чим далі завдання просунулось (ближче до завершення), тим вище —
 * «Розпочато розвантаження» над «Розпочато виконання». Рівні статуси — за плановим завантаженням.
 */
export const sortCurrentTasks = <T extends OrderedTask>(tasks: T[]): T[] =>
    [...tasks].sort(
        (a, b) =>
            IN_PROGRESS_STATUSES.indexOf(b.status) - IN_PROGRESS_STATUSES.indexOf(a.status) || byPlannedLoading(a, b)
    )

/** «Далі»: за датою й часом планового завантаження, найближче — вище; без дати — в кінці */
export const sortNextTasks = <T extends OrderedTask>(tasks: T[]): T[] => [...tasks].sort(byPlannedLoading)
